<template>
  <div class="block cas-width" :style="{width: dvWidth}">
    <el-carousel trigger="click" height="600px" width="100%">
      <el-carousel-item v-for="(item, index) in imgSrc" :key="index">
        <h3 class="small">{{ item.name }}</h3>
        <el-image :src="item.url" fit="fit" style="height:100%; width:100%;"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "CarouselPlugin",
  props: {
    dvWidth: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      imgSrc: [
        //{name: '', url: require('../assets/images/06-04-01.png')}
        {name: '', url: require('../assets/images/06-04-01-01.png')}
       /* {name: '', url: require('../assets/images/06-04-02.png')}*/
      ]
    }
  }
}
</script>

<style scoped>
  .cas-width {
    display: inline-block;
  }
</style>
